export default __webpack_public_path__ + "static/media/img6.4ef806c2.png";